
import "core-js/stable";
import "regenerator-runtime/runtime";
import { runApp, IAppConfig } from 'ice';
import Context from './context';
import { message, ConfigProvider } from 'antd';
import defaultSettingsObj from '@/defaultSettings';

// 主题配置
// ConfigProvider.config({
//   theme: {
//     primaryColor: '#44bb55',
//   },
// });

const { appConfig: AppConfig } = defaultSettingsObj;

const appConfig: IAppConfig = {
  app: {
    rootId: 'ice-container',
    getInitialData: async () => {
      // userClient.LoginApi.getDomain({}).then((res: any) => {
      //   sessionStorage.setItem('httpUrl', JSON.stringify(res.data));
      // });
      // const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      // link.type = 'image/x-icon';
      // link.rel = 'shortcut icon';
      // link.href = imgUrlHandle(AppConfig.icon.logo2);
      // document.getElementsByTagName('head')[0].appendChild(link);
      // document.title = AppConfig.title;
      const goNavFn = (obj, i) => {
        const nav = JSON.parse(sessionStorage.getItem('nav'));
        const keys = nav.findIndex((it) => it.uri === obj.uri);
        const indexObj = keys > -1 ? nav[keys + 1] : {};
        if (keys > -1) {
          if (obj?.delType) {
            if (obj?.backUri) {
              nav.splice(keys, 1);
              obj.history.push({
                pathname: obj.backUri,
                state: {},
              });
            } else {
              nav.splice(keys, 1);
              obj.history.push({
                pathname: indexObj.uri,
                state: indexObj,
              });
            }
            sessionStorage.setItem('nav', JSON.stringify(nav));
          }
        } else if ([...nav, obj].length <= 10) {
          sessionStorage.setItem('nav', JSON.stringify([...nav, obj]));
        } else {
          message.warning('选项卡最多支持10个');
        }
      };
      window.goNavFn = goNavFn;
      return Context.init();
    },
  },
  router: {
    type: 'hash',
  },
};

runApp(appConfig);

  